import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetRenewalQuoteStatus($businessId: ID!) {
    salesRenewalQuoteStatus(businessId: $businessId) {
      status
      errorType
      errorMessage
      isManual
      isEvergreen
      sentForSignature {
        seconds
      }
      evergreenBackstopDate {
        seconds
      }
    }
  }
`

export const getRenewalQuoteStatusKey = getQueryNames(query)[0]

export default query
